import React from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';
import { RowButton } from '@eika/button';
import { Loader } from '@eika/loader';

import type { Receiver } from '../../../../generated-types';
import { ReceiverElement } from '../../../../widgets/Receivers/ReceiverElement';

import './ReceiverListItem.scss';

interface Props {
    receiver: ReceiverElement | Receiver;
    onClick: () => void;
    loading?: boolean;
}

const ReceiverListItem: React.FC<Props> = ({ receiver, onClick, loading }) => {
    return (
        <RowButton className="receiver-list-item__button" onClick={onClick}>
            <div className="receiver-list-item__list-item">
                <span className="receiver-list-item__list-item-name">{receiver.name}</span>
                <span className="receiver-list-item__list-item-number" data-testid="receiver-account-number">
                    {formatAccountNumber(receiver.accountNumber)}
                </span>
            </div>
            {loading && (
                <div className="receiver-list-item__spinner">
                    <Loader mini />
                </div>
            )}
        </RowButton>
    );
};

export default ReceiverListItem;
